import { render, staticRenderFns } from "./VPaginationButton.vue?vue&type=template&id=1b902438&"
import script from "./VPaginationButton.vue?vue&type=script&lang=js&"
export * from "./VPaginationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports